import type { Locale } from "next-intl";



export * from "./common";
export * from "./NewsletterForm";
export * from "./BecomePartnerForm";

export type { Locale };


type AnyExtraProps = { [k in string]: any };
type AnyExtraParams = { [k in string]: any };


export type AppRouteProps<T extends AnyExtraParams = {}> = Readonly<{
  params: Promise<AppRouteParams<T>>;
}>;


export type AppRouteParams<T extends AnyExtraParams = {}> = (
  Readonly<T & { locale: Locale }>
);


export type PageProps<T extends AnyExtraProps = {}> = (
  Readonly<T & { locale: Locale }>
);
